import { Edge, SelectableIntermediatePost, SelectablePicket } from '../proTools/object3D';
import { Injectable } from '@angular/core';
import { DrawingsHolderService } from './drawings-holder.service';

@Injectable()
export class EdgesControlsServcie {
  private isPostSelected = false;
  constructor(
    private drawings: DrawingsHolderService,
    private drawingsHolderService: DrawingsHolderService
  ) {
    drawingsHolderService.onSelect.subscribe(obj => {
      if (obj) {
        this.isPostSelected =
          obj[0] instanceof SelectableIntermediatePost || obj[0] instanceof SelectablePicket;
        this.setEdgesVisibility(this.isPostSelected);
      }
    });
  }

  setEdgesVisibility(needVisibleEdges) {
    const edges = this.drawings.canvas.children.filter(ch => ch instanceof Edge);
    edges.forEach(edge => {
      edge.visible = needVisibleEdges === true || this.isPostSelected;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/proTools/edges-controls.service.ts